import { useEffect } from "react";
import { api } from "@/lib/api";

function hexToRgb(hex) {
  const h = (hex || "").replace("#", "");
  const n = parseInt(h.length === 3 ? h.split("").map((c) => c + c).join("") : h, 16);
  return `${(n >> 16) & 255} ${(n >> 8) & 255} ${n & 255}`;
}

// Apply a theme object {mode, accent, accentHover, bg, surface, surface2, border, text, ...} to :root.
export function applyTheme(t) {
  if (!t) return;
  const root = document.documentElement;
  const s = root.style;
  root.setAttribute("data-theme-mode", t.mode === "light" ? "light" : "dark");
  s.setProperty("--accent", t.accent);
  s.setProperty("--accent-rgb", hexToRgb(t.accent));
  s.setProperty("--accent-hover", t.accentHover);
  s.setProperty("--bg", t.bg);
  s.setProperty("--bg-rgb", hexToRgb(t.bg));
  s.setProperty("--surface", t.surface);
  s.setProperty("--surface2", t.surface2);
  s.setProperty("--surface3", t.surface2);
  s.setProperty("--surface4", t.surface);
  s.setProperty("--border", t.border);
  // Keep the legacy --fs-* tokens (scrollbar, ::selection, body text) in sync too.
  s.setProperty("--fs-primary", t.accent);
  s.setProperty("--fs-primary-hover", t.accentHover);
  s.setProperty("--fs-bg", t.bg);
  s.setProperty("--fs-surface", t.surface2);
  s.setProperty("--fs-border", t.border);
  if (t.text) s.setProperty("--fs-text", t.text);
}

const CACHE_KEY = "fs_active_theme";

// Fetches the active theme once and applies it site-wide. Uses a cached theme for an
// instant paint, then refreshes from the backend.
export function ThemeApplier() {
  useEffect(() => {
    try {
      const cached = localStorage.getItem(CACHE_KEY);
      if (cached) applyTheme(JSON.parse(cached));
    } catch { /* ignore */ }
    api.get("/theme")
      .then(({ data }) => {
        applyTheme(data);
        try { localStorage.setItem(CACHE_KEY, JSON.stringify(data)); } catch { /* ignore */ }
      })
      .catch(() => {});
  }, []);
  return null;
}
